var map = {
	"../../../app/channel/channel-detail/channel-detail.module": [
		"./src/app/channel/channel-detail/channel-detail.module.ts",
		"app-channel-channel-detail-channel-detail-module~app-channel-channel-module"
	],
	"../../../app/content/content-detail/content-detail.module": [
		"./src/app/content/content-detail/content-detail.module.ts",
		"app-content-content-detail-content-detail-module~app-content-content-module"
	],
	"../../../app/exhibition/exhibition-detail/exhibition-detail.module": [
		"./src/app/exhibition/exhibition-detail/exhibition-detail.module.ts",
		"app-exhibition-exhibition-detail-exhibition-detail-module~app-exhibition-exhibition-module"
	],
	"../../../app/game/game-detail/game-detail.module": [
		"./src/app/game/game-detail/game-detail.module.ts",
		"app-game-game-detail-game-detail-module~app-game-game-module~element-element-module~level-level-deta~d06b414e",
		"app-game-game-detail-game-detail-module~app-game-game-module~level-level-detail-level-detail-module",
		"app-game-game-detail-game-detail-module~app-game-game-module"
	],
	"../../../app/group/group-detail/group-detail.module": [
		"./src/app/group/group-detail/group-detail.module.ts",
		"app-group-group-detail-group-detail-module~app-group-group-module"
	],
	"../../../app/station/station-detail/station-detail.module": [
		"./src/app/station/station-detail/station-detail.module.ts",
		"app-station-station-detail-station-detail-module~app-station-station-module"
	],
	"../../../app/tour/tour-detail/tour-detail.module": [
		"./src/app/tour/tour-detail/tour-detail.module.ts",
		"app-tour-tour-detail-tour-detail-module~app-tour-tour-module"
	],
	"../app/cdn/cdn.module": [
		"./src/app/cdn/cdn.module.ts",
		"app-cdn-cdn-module"
	],
	"../app/channel/channel.module": [
		"./src/app/channel/channel.module.ts",
		"app-channel-channel-detail-channel-detail-module~app-channel-channel-module",
		"app-channel-channel-module"
	],
	"../app/community/community.module": [
		"./src/app/community/community.module.ts",
		"app-community-community-module"
	],
	"../app/community/user-content/user-content.module": [
		"./src/app/community/user-content/user-content.module.ts",
		"user-content-user-content-module"
	],
	"../app/content/content.module": [
		"./src/app/content/content.module.ts",
		"app-content-content-detail-content-detail-module~app-content-content-module",
		"app-content-content-module"
	],
	"../app/exhibition/exhibition.module": [
		"./src/app/exhibition/exhibition.module.ts",
		"app-exhibition-exhibition-detail-exhibition-detail-module~app-exhibition-exhibition-module",
		"app-exhibition-exhibition-module"
	],
	"../app/game/game.module": [
		"./src/app/game/game.module.ts",
		"app-game-game-detail-game-detail-module~app-game-game-module~element-element-module~level-level-deta~d06b414e",
		"app-game-game-detail-game-detail-module~app-game-game-module~level-level-detail-level-detail-module",
		"app-game-game-detail-game-detail-module~app-game-game-module",
		"app-game-game-module"
	],
	"../app/group/group.module": [
		"./src/app/group/group.module.ts",
		"app-group-group-detail-group-detail-module~app-group-group-module",
		"app-group-group-module"
	],
	"../app/html/html.module": [
		"./src/app/html/html.module.ts",
		"app-html-html-module"
	],
	"../app/map/map.module": [
		"./src/app/map/map.module.ts",
		"app-map-map-module"
	],
	"../app/organization/organization.module": [
		"./src/app/organization/organization.module.ts",
		"app-organization-organization-module~app-user-user-module",
		"app-organization-organization-module"
	],
	"../app/station/station.module": [
		"./src/app/station/station.module.ts",
		"app-station-station-detail-station-detail-module~app-station-station-module",
		"app-station-station-module"
	],
	"../app/tour/tour.module": [
		"./src/app/tour/tour.module.ts",
		"app-tour-tour-detail-tour-detail-module~app-tour-tour-module",
		"app-tour-tour-module"
	],
	"../app/user/user.module": [
		"./src/app/user/user.module.ts",
		"app-organization-organization-module~app-user-user-module",
		"app-user-user-module"
	],
	"../element/element.module": [
		"./src/app/game/level/element/element.module.ts",
		"app-game-game-detail-game-detail-module~app-game-game-module~element-element-module~level-level-deta~d06b414e",
		"element-element-module"
	],
	"../level/level-detail/level-detail.module": [
		"./src/app/game/level/level-detail/level-detail.module.ts",
		"app-game-game-detail-game-detail-module~app-game-game-module~element-element-module~level-level-deta~d06b414e",
		"app-game-game-detail-game-detail-module~app-game-game-module~level-level-detail-level-detail-module",
		"level-level-detail-level-detail-module"
	],
	"./user-content/user-content.module": [
		"./src/app/community/user-content/user-content.module.ts",
		"user-content-user-content-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;